import t from "./arrayWithHoles.js";
import e from "./iterableToArrayLimit.js";
import i from "./unsupportedIterableToArray.js";
import m from "./nonIterableRest.js";
function n(r, o) {
  return t(r) || e(r, o) || i(r, o) || m();
}
export {
  n as default
};
//# sourceMappingURL=slicedToArray.js.map
